module.exports = __webpack_public_path__ + "img/22.3917c3fe.jpg";